import styled from 'styled-components';

export const HeaderTitleWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 20px;
`;
